// Vendor imports
const _ = require('lodash')
const PropTypes = require('prop-types')
const React = require('react')
// Shared imports
const BemEntity = require('shared/bem')
// Client V1 lib imports
const airbrake = require('client/lib/airbrake')
// Client V2 common imports
const tag = require('client-v2/common/utils/hyperscript')

// BEM Block entity definition
const bem = BemEntity('LightweightEngagementTutorialCard')

function LightweightEngagementTutorialCard(props) {
  const { currentIndex, slideIndex } = props
  const videoRef = React.useRef(null)
  React.useEffect(() => {
    const shouldRestartVideo = currentIndex === slideIndex
    const videoEl = videoRef.current
    if (videoEl) {
      try {
        videoEl.pause()
        if (shouldRestartVideo) {
          videoEl.currentTime = 0
          videoEl.play()
        }
      } catch (err) {
        // Browser prevented video playback
        airbrake.notify(err)
      }
    }
  }, [currentIndex, slideIndex])

  return (
    tag('div', {
      className: bem.block()
    },
      tag('div', {
        className: bem.element('inner')
      },
        tag('video', {
          ref: videoRef,
          className: bem.element('animation'),
          autoPlay: true,
          crossOrigin: 'anonymous',
          loop: false,
          muted: true,
          playsInline: true,
          poster: props.posterUrl,
          src: props.videoUrl,
          'x-webkit-airplay': 'deny'
        }),
        tag(LightweightEngagementTutorialCardMessage, {
          html: props.messageHtml,
          text: props.messageText
        })
      ),
      tag(LightweightEngagementTutorialCardFooter, props)
    )
  )
}

LightweightEngagementTutorialCard.propTypes = {
  // Values
  className: PropTypes.string,
  currentIndex: PropTypes.number,
  messageHtml: PropTypes.string,
  messageText: PropTypes.string,
  posterUrl: PropTypes.string,
  videoUrl: PropTypes.string,
  slideCount: PropTypes.number,
  slideIndex: PropTypes.number,
  // Callbacks
  onComplete: PropTypes.func,
  onNext: PropTypes.func
}

module.exports = LightweightEngagementTutorialCard

function LightweightEngagementTutorialCardMessage(props) {
  if (props.html) {
    return (
      tag('div', {
        className: bem.element('message'),
        dangerouslySetInnerHTML: { __html: props.html }
      })
    )
  }
  if (props.text) {
    return (
      tag('div', {
        className: bem.element('message')
      },
        props.text
      )
    )
  }
  return null
}

function LightweightEngagementTutorialCardFooter(props) {
  const { slideIndex, slideCount } = props
  const isLastSlide = slideIndex === slideCount - 1
  return (
    tag('div', {
      className: bem.element('footer')
    },
      tag('button', {
        className: bem.element('footer-button', {
          hidden: isLastSlide,
          skip: !isLastSlide
        }),
        onClick: props.onComplete
      },
        'Skip'
      ),
      tag('div', {
        className: bem.element('progress')
      },
        _.range(slideCount).map(dotIndex => (
          tag('div', {
            key: `${dotIndex}`,
            className: bem.element('progress-dot', {
              active: dotIndex === slideIndex
            })
          })
        ))
      ),
      tag('button', {
        className: bem.element('footer-button', 'next'),
        onClick: props.onNext
      },
        isLastSlide ? 'Done' : 'Next'
      )
    )
  )
}
